/**
 * Mounts the agent panel once for the signed-in app and applies `?agent=`
 * deep links. Lives under the realtime + notifications providers.
 */
import type { FC } from "react";

import { useAgentPanelDeepLink } from "../useAgentPanelDeepLink";
import { AgentPanel } from "./AgentPanel";

export const AgentPanelHost: FC = () => {
  useAgentPanelDeepLink();
  return <AgentPanel />;
};
